// API URLs
export const NOTEBOOKS_URL = '/api/notebooks/';
export const NOTEBOOK_TAGS_URL = '/api/notebooks/tags/';

// Page URLs
export const USER_LOGIN_URL = '/accounts/login/'

// Static resources
export const EMPTY_MY_NOTEBOOKS = '/static/images/notebooks/mynotebooks.png'
export const EMPTY_FAVORITE_NOTEBOOKS = '/static/images/notebooks/favourites.png'
export const SERVER_ERROR_IMAGE = undefined;

// Misc
export const HTTP_DEBOUNCE_TIME = 500;
export const MIN_NB_TITLE_LENGTH = 5;
export const MIN_NB_SUMMARY_LENGTH = 10;
